"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"

export function PaygSuccessNotice({ credits }: { credits: number }) {
    const router = useRouter()

    useEffect(() => {
        const timer = window.setTimeout(() => {
            router.replace("/")
        }, 6000)
        return () => window.clearTimeout(timer)
    }, [router])

    return (
        <div
            className="mx-6 mt-6 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800 md:mx-0"
            role="status"
        >
            Purchase complete — {credits.toLocaleString()} credits have been added to your balance.
        </div>
    )
}
